module.exports = __webpack_public_path__ + "static/img/4.dff3d54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/4.png
// module id = 9uYa
// module chunks = 0